import { createContext, useContext, useMemo, type Dispatch, type PropsWithChildren, type SetStateAction } from 'react';

export const MOBILE_SYMBOL_DEEP_DIVE_MODULES = [
  { id: 'order-book', label: 'Order book' },
  { id: 'volume-ladder', label: 'Volume ladder' },
  { id: 'historical-price-chart', label: 'Historical price chart' },
  { id: 'price-ladder', label: 'Price ladder' },
] as const;

export const MOBILE_SYMBOL_DEEP_DIVE_MODULE_COUNT = MOBILE_SYMBOL_DEEP_DIVE_MODULES.length;

export type MobileSymbolDeepDiveModuleIndex = 0 | 1 | 2 | 3;

interface MobileSymbolDeepDiveModuleContextValue {
  moduleIndex: MobileSymbolDeepDiveModuleIndex;
  setModuleIndex: Dispatch<SetStateAction<MobileSymbolDeepDiveModuleIndex>>;
}

const MobileSymbolDeepDiveModuleContext = createContext<MobileSymbolDeepDiveModuleContextValue | null>(null);

export function useMobileSymbolDeepDiveModuleContext() {
  const context = useContext(MobileSymbolDeepDiveModuleContext);
  if (context == null) {
    throw new Error('useMobileSymbolDeepDiveModuleContext must be used within MobileSymbolDeepDiveModuleProvider');
  }
  return context;
}

export function MobileSymbolDeepDiveModuleProvider({
  children,
  moduleIndex,
  setModuleIndex,
}: PropsWithChildren<MobileSymbolDeepDiveModuleContextValue>) {
  const value = useMemo(() => ({ moduleIndex, setModuleIndex }), [moduleIndex, setModuleIndex]);
  return (
    <MobileSymbolDeepDiveModuleContext.Provider value={value}>{children}</MobileSymbolDeepDiveModuleContext.Provider>
  );
}
